import React from 'react';
import GekkoAvatar from './GekkoAvatar';

interface ChatHeaderProps {
  department: string;
  gekkoName: string;
}

export default function ChatHeader({ department, gekkoName }: ChatHeaderProps) {
  return (
    <div className="flex items-center space-x-3 p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-white">
      <GekkoAvatar gekkoName={gekkoName} />
      <div>
        <h3 className="font-medium text-gray-900">{gekkoName}</h3>
        <p className="text-sm text-gray-500">{department}</p>
      </div>
    </div>
  );
}